// src/components/ConversationList.js

import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Input,
  Button,
  Spinner,
  Badge,
  Card,
  CardBody,
  InputGroup,
  InputLeftElement,
  Heading,
  Divider,
  Flex,
  IconButton,
  Tooltip,
  Link, Image
} from '@chakra-ui/react';
// import { SearchIcon, CalendarIcon, CloseIcon } from '@chakra-ui/icons';
import { FiSearch, FiCalendar, FiX } from 'react-icons/fi';
import { useAdminConversations } from '../hooks/useAdminConversations';
import { FiRefreshCw } from 'react-icons/fi';

export default function ConversationList({ 
  // onSelectConversation, selectedSessionId
 }) {
  const {
    conversations,
    loading,
    error,
    searchTerm,
    setSearchTerm,
    selectedDate,
    setSelectedDate,
    refreshConversations
  } = useAdminConversations();

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('en-IN', {
      dateStyle: 'medium',
      timeStyle: 'short'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'green';
      case 'closed': return 'gray';
      default: return 'blue';
    }
  };

  const clearFilters = () => {
    setSearchTerm('');
    setSelectedDate('');
  };

  const hasActiveFilters = searchTerm || selectedDate;

  return (
    <Box h="100vh" bg="#FAFAFA" borderRight="1px solid" borderColor="#E0E0E0" overflowY="auto">
      <VStack spacing="4" align="stretch" p="4">
        {/* Header */}
        <HStack justify="space-between" mb="2">
          {/* <Heading size="lg" color="#242424">Conversations</Heading> */}
          <Link href="https://app.alpherra.com/" isExternal>
            <Image
              src="/logoHeader.svg"
              alt="Logo"
              h="clamp(24px, 2vw, 38px)"
            />
          </Link>
          <Button
            leftIcon={<FiRefreshCw  />}
            onClick={refreshConversations}
            colorScheme="blue"
            size="sm"
          >
            Refresh
          </Button>
        </HStack>

        {/* Search & Filter Row */}
        <HStack spacing="2">
          {/* Search Input */}
          <InputGroup size="md" flex="2">
            <InputLeftElement pointerEvents="none">
              <FiSearch color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Search by chat name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              bg="white"
              borderColor="#D0D0D0"
            />
          </InputGroup>

          {/* Date Filter */}
          <InputGroup size="md" flex="1">
            <InputLeftElement pointerEvents="none">
              <FiCalendar color="gray.400" />
            </InputLeftElement>
            <Input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              bg="white"
              borderColor="#D0D0D0"
              placeholder="Filter by date"
            />
          </InputGroup>

          {/* Clear Filters Button */}
          {hasActiveFilters && (
            <Button
              size="md"
              colorScheme="red"
              variant="outline"
              onClick={clearFilters}
            // leftIcon={<CloseIcon />}
            >
              Clear Filters
            </Button>
          )}
        </HStack>

        {/* Stats */}
        {/* <HStack spacing="4" fontSize="sm" color="#666" bg="white" p="3" borderRadius="8px" border="1px solid #E0E0E0">
          <Flex align="center" gap="2">
            <Text fontWeight="700" fontSize="lg" color="#2196F3">{conversations.length}</Text>
            <Text>Total</Text>
          </Flex>
          <Divider orientation="vertical" h="20px" />
          <Flex align="center" gap="2">
            <Text fontWeight="700" fontSize="lg" color="#4CAF50">{conversations.filter(c => c.status === 'active').length}</Text>
            <Text>Active</Text>
          </Flex>
          <Divider orientation="vertical" h="20px" />
          <Flex align="center" gap="2">
            <Text fontWeight="700" fontSize="lg" color="#999">{conversations.filter(c => c.status === 'closed').length}</Text>
            <Text>Closed</Text>
          </Flex>
        </HStack> */}

        <Divider />

        {/* Active Filter Indicator */}
        {hasActiveFilters && (
          <Box bg="#E3F2FD" p="2" borderRadius="6px" fontSize="sm" color="#1976D2">
            <HStack>
              <Text fontWeight="600">Active Filters:</Text>
              {searchTerm && <Badge colorScheme="blue">Search: {searchTerm}</Badge>}
              {selectedDate && <Badge colorScheme="blue">Date: {new Date(selectedDate).toLocaleDateString('en-IN')}</Badge>}
            </HStack>
          </Box>
        )}

        {/* Conversation List */}
        {loading ? (
          <Box textAlign="center" py="8">
            <Spinner size="xl" color="blue.500" />
            <Text mt="4" color="#666">Loading conversations...</Text>
          </Box>
        ) : error ? (
          <Box textAlign="center" py="8">
            <Text color="red.500">Error: {error}</Text>
          </Box>
        ) : conversations.length === 0 ? (
          <Box textAlign="center" py="8">
            <Text color="#999">
              {hasActiveFilters ? 'No conversations match your filters' : 'No conversations found'}
            </Text>
            {hasActiveFilters && (
              <Button size="sm" mt="3" onClick={clearFilters} colorScheme="blue" variant="outline">
                Clear Filters
              </Button>
            )}
          </Box>
        ) : (
          <VStack spacing="3" align="stretch">
            {conversations.map((conversation) => {
              // const isSelected = selectedSessionId === conversation.id;
              return (
                <Card
                  key={conversation.id}
                  // cursor="pointer"
                  // onClick={() => onSelectConversation(conversation.id)}
                  bg={'white'}
                  borderColor={'#E0E0E0'}
                  borderWidth="1px"
                  _hover={{
                    bg:'#F5F5F5',
                    borderColor: '#2196F3',
                    transform: 'translateY(-2px)',
                    boxShadow: 'sm'
                  }}
                  transition="all 0.2s"
                >
                  <CardBody p="4">
                    <HStack justify="space-between" mb="2">
                      <Heading size="sm" color="#242424" noOfLines={1}>
                        {conversation.chatName || 'Untitled Chat'}
                      </Heading>
                      {/* <Badge colorScheme={getStatusColor(conversation.status)}>
                        {conversation.status || 'unknown'}
                      </Badge> */}
                      {/* Open Chat Button */}
                      <Button
                        size="sm"
                        colorScheme="blue"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent card click event
                          window.open(`/chat/${conversation.id}`, '_blank');
                        }}
                      >
                        Open Chat
                      </Button>
                    </HStack>

                    <VStack align="stretch" spacing="1" fontSize="xs" color="#666">
                      <HStack>
                        <Text fontWeight="500">Session ID:</Text>
                        <Text fontFamily="mono">{conversation.id.substring(0, 12)}...</Text>
                      </HStack>
                      <HStack>
                        <Text fontWeight="500">Started:</Text>
                        <Text>{formatDate(conversation.startTime)}</Text>
                      </HStack>
                      {/* <HStack>
                        <Text fontWeight="500">Turns:</Text>
                        <Text>{conversation.turnCount || 0}</Text>
                      </HStack> */}
                    </VStack>
                  </CardBody>
                </Card>
              );
            })}
          </VStack>
        )}
      </VStack>
    </Box>
  );
}
